var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRowDrag = function SvgRowDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 19",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.033a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm0 4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm5.25-4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm0 4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm5.25-4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm0 4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0z",
    fill: "#48525C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.033a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm0 4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm5.25-4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm0 4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm5.25-4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm0 4.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0z",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRowDrag;